// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
//
// Deep import, NOT the main barrel (`@livingsyncs/ui`) — fixed 2026-09-12,
// second occurrence of the same bug already fixed once in sentry.ts (see that
// file's own comment and gotcha_barrel_import_freezes_platform_bridge_undefined).
// This file is what NativeSessionGuard.tsx's `desktop`/`isCapacitor` actually
// come from, so importing the WHOLE barrel here — just to implement
// getPublicAppUrl() as a real function declaration rather than a reference
// copy — put platform.ts's own consts back at risk of the exact evaluation-
// order bug the sentry.ts fix was supposed to close: confirmed live via a
// diagnostic fetch from a real device build, `desktop` was still frozen
// undefined (sameRef: false against the live, correctly-populated
// window.livingsyncs) even AFTER the sentry.ts fix shipped. Deep-importing
// packages/ui/src/lib/platform.ts directly — the same single file that
// already defines every symbol below — means this module's own import graph
// can never again land it in a bundling context that races capacitorBridge.ts.
import * as _platformModule from "@livingsyncs/ui/src/lib/platform";

export {
  desktop,
  isCapacitor,
  isElectron,
  isNative,
} from "@livingsyncs/ui/src/lib/platform";

export function getPublicAppUrl() {
  return _platformModule.getPublicAppUrl();
}

export type {
  LivingSyncsTokenStore,
  UpdateErrorKind,
  LivingSyncsBridge,
} from "@livingsyncs/ui/src/lib/platform";
